module.exports = __webpack_public_path__ + "77c1a8b365e3a4b52f9fc74817755309.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/img_featurette_H460px.png
// module id = 400
// module chunks = 0